import * as React from 'react';
import { Form } from 'antd';
import { FormItemProps } from 'antd/lib/form';
import { getMessageText } from '../../helper/getWidgetInputText';
import { IWidgetInput } from 'common/schema/widget/input/WidgetInput';
import { getWidgetLayoutFromSetup } from '../../setup/layout/getWidgetLayoutFromSetup';
import { WidgetLayout } from 'common/schema/widget/WidgetLayout';
import classNames from 'classnames';

export interface WidgetInputFormItemProps extends FormItemProps {
  input: IWidgetInput;
}

/**
 * Form Item di Ant solo per visualizzazione di anteprima nel widget dei campi di input
 * */
export function WidgetInputFormItem(props: WidgetInputFormItemProps) {
  const { input, ...otherProps } = props;

  const label = input.label;
  // TODO: verificare se possibile eliminare ...message (oppure da implementate?)
  const message = getMessageText(input);
  const layout = getWidgetLayoutFromSetup(input);
  const isLabelEmpty = !label?.trim();

  return (
    <Form.Item
      label={isLabelEmpty ? undefined : label}
      colon={!isLabelEmpty}
      {...message}
      {...otherProps}
      {...layout}
      className={classNames(props.className, {
        'form-item--vertical': input.extra?.layout === WidgetLayout.Vertical
      })}
    />
  );
}
